import * as Types from '../types/gql';

export type EnabledInstrument = {
  type: Types.ClearingWithdrawInstrumentType;
  minimum: number;
  maximum: number;
  currency: string;
  instrumentId?: Types.Maybe<string>;
  fee:
    | {
        __typename: 'ClearingWithdrawFixedFee';
        amount: { value: string; currency: { code: string } };
      }
    | { __typename: 'ClearingWithdrawPercentFee'; percent?: Types.Maybe<number> };
};

export type WithdrawInstrumentsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type WithdrawInstrumentsQuery = {
  clearing?: Types.Maybe<{ withdrawInstrumentsV2?: Types.Maybe<Array<EnabledInstrument>> }>;
};
